const withQuery = (path, params) => {
  const query = new URLSearchParams(Object.entries(params).filter(([, value]) => value)).toString();
  return query ? `${path}?${query}` : path;
};

export const bannersPath = ({ screen, placement, franchiseId } = {}) =>
  withQuery("/home-banners", { screen, placement, franchise: franchiseId });

export const sectionPath = (section, franchiseId) =>
  withQuery(`/home-banners/section/${section.id}`, { franchise: franchiseId });

export const SCREEN_LABELS = { home: "Home", surplus: "Surplus" };
